import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateDailyGoalInput, PatchDailyGoalInput } from "@consistency-circle/shared";

import { apiClient } from "../../../lib/api";
import { dailyGoalsQueryKey, dashboardQueryKey } from "../constants";

export function useGoalMutations({
  onClose,
  onError,
}: {
  readonly onClose: () => void;
  readonly onError: (message: string) => void;
}) {
  const queryClient = useQueryClient();

  const handleSuccess = () => {
    void queryClient.invalidateQueries({ queryKey: dailyGoalsQueryKey });
    void queryClient.invalidateQueries({ queryKey: dashboardQueryKey });
    onClose();
  };

  const handleError = (error: Error) => onError(error.message);

  const createMutation = useMutation({
    mutationFn: (input: CreateDailyGoalInput) => apiClient.createDailyGoal(input),
    onSuccess: handleSuccess,
    onError: handleError,
  });

  const patchMutation = useMutation({
    mutationFn: ({ id, input }: { id: string; input: PatchDailyGoalInput }) =>
      apiClient.patchDailyGoal(id, input),
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return { createMutation, patchMutation };
}
